import { axiosPrivate } from '../../api/axios';
import {
    setCalendarLoading,
    setCalendarData,
    setCalendarError,
} from '../reducers/calendar';

export const fetchCalendar = ({ from, to }) => async (dispatch) => {
    dispatch(setCalendarLoading(true));
    try {
        const response = await axiosPrivate.get('/api/calendar', {
            params: {
                from: from instanceof Date ? from.toISOString() : from,
                to: to instanceof Date ? to.toISOString() : to,
            },
        });

        if (response.status === 200) {
            dispatch(setCalendarData(response.data));
        }
    } catch (error) {
        dispatch(setCalendarError(
            error?.response?.data?.message || 'No se pudo cargar el calendario.',
        ));
    }
};
